var _title, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 27 27"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Phone Icon")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m21.81 17.302-5.448 1.056c-3.68-1.847-5.952-3.969-7.275-7.276l1.018-5.463L8.18.5H3.218C1.727.5.552 1.733.775 3.207c.556 3.682 2.196 10.358 6.989 15.15 5.033 5.034 12.283 7.218 16.273 8.087 1.54.335 2.908-.867 2.908-2.444V19.26z"
  })));
};
export default SvgPhone;